function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.number.constructor.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// TODO: is this component still in use? Consider dropping in Currency v2
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './StarRating.module.less';
import { Stars } from './Stars';
export var RATING_LABELS = {
  1: 'Hate it',
  2: 'Dislike it',
  3: 'It’s OK',
  4: 'Like it',
  5: 'Love it'
};
/** produces an interactive star rating */

export var StarRatingInput = /*#__PURE__*/function (_Component) {
  _inherits(StarRatingInput, _Component);

  var _super = _createSuper(StarRatingInput);

  function StarRatingInput(props) {
    var _this;

    _classCallCheck(this, StarRatingInput);

    _this = _super.call(this, props);
    _this.state = {
      rating: props.rating || 0
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  _createClass(StarRatingInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      // rating can still be controlled when needed
      var rating = newProps.rating;
      var currentRating = this.props.rating;
      var changed = rating !== currentRating;

      if (changed) {
        this.setState({
          rating: rating
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var value = e.target.value;
      var currentRating = this.state.rating;
      var onChange = this.props.onChange;
      var newRating = Number(value); // if rating is the same, unset

      var rating = currentRating === newRating ? 0 : newRating;
      this.setState({
        rating: rating
      });
      onChange(rating);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          error = _this$props.error,
          id = _this$props.id,
          label = _this$props.label,
          maxRating = _this$props.maxRating,
          nerdwallet = _this$props.nerdwallet,
          ratingLabels = _this$props.ratingLabels;
      var rating = this.state.rating;
      var PROMPT = 'Select your rating';
      var FIELDSET_ID = id && "".concat(id, "__fieldset");
      var LEGEND_ID = id && "".concat(id, "__legend");
      var OUTPUT_ID = id && "".concat(id, "__output");
      var containerClasses = classNames(styles.container, className);
      return /*#__PURE__*/React.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/React.createElement("fieldset", {
        className: classNames(styles.stars, styles["star-".concat(rating, "-clicked")]),
        disabled: disabled,
        "aria-labelledby": label && LEGEND_ID,
        "aria-label": !label && PROMPT,
        "aria-describedby": OUTPUT_ID
      }, label && /*#__PURE__*/React.createElement("span", {
        id: LEGEND_ID,
        className: styles.legend
      }, label), /*#__PURE__*/React.createElement(Stars, {
        id: id,
        error: error,
        maxRating: maxRating,
        nerdwallet: nerdwallet,
        onClick: this.handleClick,
        rating: rating
      })), ratingLabels && /*#__PURE__*/React.createElement("output", {
        id: OUTPUT_ID,
        htmlFor: FIELDSET_ID,
        className: styles.output
      }, ratingLabels[rating] || PROMPT));
    }
  }]);

  return StarRatingInput;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

StarRatingInput.displayName = 'StarRatingInput';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  StarRatingInput.propTypes = {
    /** Class on the outer container element. */
    className: PropTypes.string,

    /** Whether the input is disabled. */
    disabled: PropTypes.bool,

    /** Whether the input is in an error state. */
    error: PropTypes.bool,

    /** Id used for accessibility. */
    id: PropTypes.string.isRequired,

    /** Label for the input. */
    label: PropTypes.string,

    /** Maximum star rating. */
    maxRating: PropTypes.number,

    /** Whether this is a "NerdWallet" rating, making the stars green. */
    nerdwallet: PropTypes.bool,

    /** Callback function called when a rating is selected. */
    onChange: PropTypes.func,

    /** Current star rating. */
    rating: PropTypes.number,

    /** Object mapping each rating value to its label or a flag indicating to hide the rating labels. */
    ratingLabels: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.bool])
  };
} // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


StarRatingInput.defaultProps = {
  className: null,
  disabled: false,
  error: false,
  label: null,
  maxRating: 5,
  nerdwallet: false,
  onChange: function onChange() {},
  rating: 0,
  ratingLabels: RATING_LABELS
};